import { EmploymentStatus, VgEmploymentState } from '@interfaces';
import { FilteredClientAccount } from '@shared/models';
import {
  ISelectedClientAccountsState,
  TransactionTypesEnum,
} from '@store/reducers/selected-client-accounts/selected-client-accounts.reducer';

export const getMinorTransferFromNextPage = (individualAccounts: FilteredClientAccount): string =>
  individualAccounts.accounts.length > 0
    ? 'secure/minor-transfer/transfer-to'
    : 'secure/minor-transfer/personal-info';
export const getMinorTransferToNextPage = (
  selectedAccounts: ISelectedClientAccountsState,
): string =>
  selectedAccounts.transactionType === TransactionTypesEnum.EXISTING
    ? 'secure/minor-transfer/review'
    : 'secure/minor-transfer/personal-info';
export const getMinorPersonalInfoNextPage = (): string => 'secure/minor-transfer/contact-info';
export const getMinorContactInfoNextPage = (): string => 'secure/minor-transfer/settlement-fund';
export const getMinorSettlementFundNextPage = (): string => 'secure/minor-transfer/employment';
export const getMinorEmploymentNextPage = (
  employment: Partial<VgEmploymentState> | undefined,
): string => {
  const isVanguardEmployee =
    employment?.employmentStatus?.employmentStatus === EmploymentStatus.VANGUARD_EMPLOYED;
  const isSpouseVanguardEmployee = employment?.associations?.spouse ?? false;
  const isAssociatedPerson = employment?.associations?.associated ?? false;

  if (isAssociatedPerson && !isVanguardEmployee && !isSpouseVanguardEmployee) {
    return 'secure/minor-transfer/upload/letter';
  }
  return getMinorLetterUploadNextPage();
};
export const getMinorIncomeNetWorthNextPage = (): string =>
  'secure/minor-transfer/investment-objectives';
export const getMinorInvestObjNextPage = (): string => 'secure/minor-transfer/review';
export const getMinorReviewNextPage = (selectedAccounts: ISelectedClientAccountsState): string =>
  selectedAccounts.transactionType === 'EXISTING'
    ? 'secure/minor-transfer/terms/existing'
    : 'secure/minor-transfer/terms/new';
export const getMinorTermsNextPage = (): string => 'secure/minor-transfer/confirm';
export const getMinorLetterUploadNextPage = (): string => 'secure/minor-transfer/income-net-worth';
export const getOpenChoiceEnrollPage = (): string => 'secure/open-choice/enroll';
